export const primary00 = '#ffefea'
export const primary01 = '#FFCFBF'
export const primary02 = '#FFAF95'
export const primary03 = '#FF8C68'
export const primary04 = '#FF6535'
export const primary05 = '#FF4D01'
export const primary06 = '#DE4201'
export const primary07 = '#BE3701'
export const primary08 = '#9E2C00'
export const primary09 = '#802200'
export const primary10 = '#631800'
export const primary11 = '#e4fbef'
export const primary12 = '#008046'

export const red00 = '#FDECEF'
export const red01 = '#FAC7CE'
export const red02 = '#F7A1AE'
export const red03 = '#F47B8E'
export const red04 = '#F15F75'
export const red05 = '#EF435D'
export const red06 = '#D73C54'
export const red07 = '#BF364A'
export const red08 = '#A72F41'
export const red09 = '#8F2838'
export const red10 = '#78212E'

export const green00 = '#E5F9F3'
export const green01 = '#B2EEDA'
export const green02 = '#80E3C2'
export const green03 = '#4CD7A9'
export const green04 = '#26CF96'
export const green05 = '#00C684'
export const green06 = '#00B277'
export const green07 = '#009E6A'
export const green08 = '#008B5C'
export const green09 = '#00774F'
export const green10 = '#006342'

export const yellow00 = '#FFFAEB'
export const yellow01 = '#FFEFC2'
export const yellow02 = '#FFE499'
export const yellow03 = '#FFD970'
export const yellow04 = '#FFD152'
export const yellow05 = '#FFC933'
export const yellow06 = '#E5B52E'
export const yellow07 = '#CCA129'
export const yellow08 = '#B38D24'
export const yellow09 = '#FDECEF'
export const yellow10 = '#99791F'

export const purple00 = '#ECE4F6'
export const purple01 = '#E1D5F1'
export const purple02 = '#C5AFE4'
export const purple03 = '#A989D7'
export const purple04 = '#8D63CA'
export const purple05 = '#7E4FC3'
export const purple06 = '#7140BA'
export const purple07 = '#6639A7'
export const purple08 = '#5A3394'
export const purple09 = '#4F2C81'
export const purple10 = '#44266E'

export const grey00 = '#F7F7F7'
export const grey01 = '#E5E5E5'
export const grey02 = '#D4D4D4'
export const grey03 = '#C3C3C3'
export const grey04 = '#B7B7B7'
export const grey05 = '#AAAAAA'
export const grey06 = '#999999'
export const grey07 = '#888888'
export const grey08 = '#777777'
export const grey09 = '#666666'
export const grey10 = '#555555'
export const grey11 = '#444444'
export const grey12 = '#333333'

export const white = '#FFFFFF'
export const black = '#000000'

export const custom00 = '#CFE7E0'
export const custom01 = '#F0F0F0'
export const custom02 = '#292929'
export const custom03 = '#ffffffcc'
export const custom04 = '#F6F7F8'
export const custom05 = '#01c684'
export const custom06 = '#2b2f41'
export const custom07 = '#fafafa'
export const custom08 = '#F6F6F6'
export const custom09 = '#00c584'
export const custom10 = '#F1F3F8'
export const custom11 = '#333'
export const custom13 = '#F5F5F5'
export const custom14 = '#1895b3'
export const custom15 = '#65656b'
export const custom16 = '#148099'
export const custom17 = '#777'
export const custom18 = '#CCCCCC'
export const custom19 = '#00B087'
export const custom20 = '#53576d'
export const custom21 = '#fffbe9'
export const custom22 = '#2677F0'
export const custom23 = '#222222'
export const custom24 = '#656565'
export const custom25 = '#757575'
export const custom26 = '#BDF2FF'
export const custom27 = '#F2F2F2'
export const custom28 = '#e9e9e9'
export const custom29 = '#878787'
export const custom30 = '#373737'
export const custom31 = '#3B4EB2'
export const custom32 = '#09B367'
export const custom33 = '#F9F9F9'
export const custom34 = '#D8D8D8'
export const custom35 = '#535353'
export const custom36 = '#008046'
export const custom37 = '#20FF9B'
export const custom38 = '#545454'
export const custom39 = '#F3F3F3'
export const custom40 = '#07A55E'
export const custom41 = '#84D9B3'
export const custom42 = '#ED5F74'
export const custom43 = '#5B5B5B'
export const custom44 = '#F57386'
export const custom45 = '#DADEF1'
